/*
 * @Author: web_liuqunyan
 * @Date: 2022-12-26 14:12:17
 * @LastEditors: 丁昊翔
 * @LastEditTime: 2025-07-23 19:02:38
 * @FilePath: \gggj_main\src\router\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from 'vue';
import Router from 'vue-router';
import Layout from '@/components/Layout';
import store from '../store/index.js';
const defaultSettings = require('../settings.js');
import { getEnterpriseAccountInfo } from '../api/login.js';
Vue.use(Router);

const routes = [
  {
    path: '/',
    name: 'index',
    redirect: '/login'
    // component: Index
  },
  {
    path: '/index',
    name: 'systemindex',
    component: () => import('../views/enterprise.vue')
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/login.vue')
  },
  {
    path: '/retrieval-password',
    name: 'retrieval-password',
    component: () => import('../views/retrieval-password.vue')
  },
  {
    path: '/register',
    name: 'register',
    component: () => import('../views/register.vue')
  },
  {
    path: '/transit-page',
    name: 'transitPage',
    component: () => import('../views/transit-page.vue')
  },
  {
    path: '/layout/*',
    component: Layout
  }
];

const createRouter = () =>
  new Router({
    scrollBehavior: () => ({
      y: 0
    }),
    routes: routes,
    mode: 'hash'
  });

const router = createRouter();

function getHashParams (paramName) {
  const hash = window.location.hash; // 获取完整的 hash 字符串，如 #/path?param1=value1&param2=value2
  const paramsStr = hash.split('?')[1]; // 提取 ? 后的参数部分

  if (!paramsStr) return null;

  const params = paramsStr.split('&'); // 按 & 分割成键值对
  for (const param of params) {
    const [key, value] = param.split('='); // 按 = 分割键和值
    if (key === paramName) {
      return decodeURIComponent(value.replace(/\+/g, ' ')); // 解码并返回对应的值
    }
  }

  return null; // 如果未找到对应参数，返回 null
}

router.beforeEach(async (to, from, next) => {
  // 路由拦截
  if (getHashParams('token')) {
    // store.dispatch('user/setToken', getHashParams('token'));
    store.commit('user/SET_TOKEN', getHashParams('token')); // 存储token

    const res = await getEnterpriseAccountInfo();
    if (res) {
      const data = res.data;
      store.commit('user/SET_USERINFO', {
        // 存储用户信息
        name: data.loginName, //data.name
        mobile: data.mobile,
        headImgUrl: data.headImgUrl,
        staffId: data.staffId,
        loginId: data.loginId,
        enterpriseId: data.enterpriseId,
        enterpriseName: data.enterpriseName,
        // erpriseList: data.staffHaveEnterpriseList
        erpriseList: data.accountHaveEnterpriseList
      });

      if (data.powerList?.length) {
        // 去掉后台管理菜单
        const menuIndex = data.powerList.findIndex((val) => val.action === '/layout/dms');
        menuIndex !== -1 && data.powerList.splice(menuIndex, 1);

        store.commit('power/SET_MENU_LIST', data.powerList); // 存储powerList

      } else {
        this.$message.warning('当前账号没有菜单权限');
      }
    }
  }
  const token = store.getters.token === '' ? false : true;
  if (token || defaultSettings.whiteList.find((whitePath) => to.path === whitePath)) {
    next();
  } else {
    next({
      path: '/login'
    });
  }
});

//解决vue路由重复导航错误
//获取原型对象上的push函数
const originalPush = Router.prototype.push;
//修改原型对象中的push方法
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch((err) => err);
};

export function resetRouter () {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher;
}

export default router;
